<template>
  <v-sheet class="foreground" height="100%">

    <keep-alive>

      <v-container class="">
        <v-row>
          <v-col sm="6">
            <v-card>
              <name-search 
              :url="url" 
              :urlArgs="urlArgs"
              ref="nameSearch" 
              @onItemSelected="onItemSelected">
              </name-search>
            </v-card>
          </v-col>
          <v-col sm="6">
            <v-card>
              <name-search-lvl2 
              :url="url" 
              :urlArgs="urlArgs"
              ref="nameSearchLvl2" 
              :key="urlArgs.id"
              @redirect="redirect">
              </name-search-lvl2>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

    </keep-alive>

  </v-sheet>
</template>

<script>
import NameSearch from '../name-search/Main'
import NameSearchLvl2 from '../name-search-lvl2/Main'

export default {
  components: {
    NameSearch,
    NameSearchLvl2
  },
  props: ['url', 'urlArgs'],
  methods: {
    init (query) {
      // this.filters.search.name = query
    },
    onOpenDrawer () {
      this.$refs.nameSearch.onOpenDrawer()
    },
    redirect (url, ...args) {
      this.$emit('redirect', url, ...args)
    },
    onItemSelected (item) {
      this.$emit('redirect', 'name-search/lvl2', item)
    }
  }
}
</script>